import { tw } from '@/utils/tw';

const ArticleDisclosureLabel = tw.theme({
  base: [
    'sticky',
    'w-full',
    'bg-black',
    'px-2',
    'py-1',
    'text-center',
    'text-white',
    'transition-transform',
    'duration-500',
    'ease-in-out',
    'wings',
    'wings-black',
    'text-body-xs',
    '!z-article-disclosure',
  ],
});

export default ArticleDisclosureLabel;
